<div class="absolute inset-0 z-40 bg-black opacity-50"></div>
<div class="absolute inset-0 z-40 grid place-items-end px-4 pb-6 md:place-items-center md:p-0">
  <div class="grid max-w-[425px] rounded-3xl bg-white p-6">
    <h1 class="prose-display-lg font-semibold" translate>{{ msg }}</h1>
    <div class="pb-3"></div>
    <span *ngIf="status + '' === '453'; else idExpiring" class="text-neutral-500" translate
      >msg.idExpiredDateMsg</span
    >
    <ng-template #idExpiring>
      <span class="text-neutral-500" translate>msg.idExpiringDateMsg</span>
    </ng-template>
    <div class="pb-10"></div>
    <button app-button (click)="uploadNow()" translate>btn.uploadNow</button>
    <div class="pb-4"></div>
    <button
      app-button
      color="secondary"
      *ngIf="status + '' === '453'; else buttonIdExpiring"
      (click)="logOut()"
      translate>
      btn.log_out
    </button>
    <ng-template #buttonIdExpiring>
      <button app-button color="secondary" (click)="closeModal.emit()" translate>btn.later</button>
    </ng-template>
  </div>
</div>
